import { Action } from '../../../common/actions/core/action';

export class OpenStudentReceivedAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/received/received.action.ts